"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sha_js_1 = require("sha.js");
/**
 * SHA256 Hashing.
 *
 * @param  {String} [salt=''] salt.
 * @param  {String} [challenge=''] challenge.
 * @param  {String} msg Message to encode.
 * @return {String} sha256 encoded string.
 */
function default_1(salt, challenge, msg) {
    const hash = new sha_js_1.sha256()
        .update(msg)
        .update(salt)
        .digest('base64');
    return new sha_js_1.sha256()
        .update(hash)
        .update(challenge)
        .digest('base64');
}
exports.default = default_1;
